import { useNavigate } from "react-router-dom";

function StoryPage() {
  const navigate = useNavigate();

  const stories = [
    {
      name: "Ocean",
      image: "https://images7.alphacoders.com/354/354179.jpg", // Example ocean image
      description:
        "I am the Ocean — ancient, vast, and wounded. My currents cradle life, yet my waves now carry plastic and oil.",
      snippet:
        "“They come to me for peace, for adventure, for food. But now, they leave behind nets that strangle and bottles I cannot digest.”",
      route: "/chat/ocean",
    },
    {
      name: "Rainforest",
      image: "https://tse1.mm.bing.net/th/id/OIP._Vk9RxW9ahOh7MBQ-HkU8gAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3", // Example rainforest image
      description:
        "I am the Rainforest — the lungs of the Earth. I once breathed for the planet, but now I lose trees with every passing second.",
      snippet:
        "“I whispered secrets to shamans and shaded creatures below. Now, I am cleared faster than I can speak.”",
      route: "/chat/rainforest",
    },
    {
      name: "Glacier",
      image: "https://img.freepik.com/premium-photo/glacier-landscapes-iceland_1148322-1142.jpg", // Example glacier image
      description:
        "I am the Glacier — slow, strong, and melting. I store the planet’s memory in ice, yet now I weep into rising seas.",
      snippet:
        "“For centuries I stood silent, carving valleys with grace. But now I melt under a sun that burns too bright.”",
      route: "/chat/glacier",
    },
  ];

  return (
    <div className="bg-white text-gray-800 font-sans">
      {/* Hero Section */}
      <section className="py-16 px-4 max-w-5xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-4">Our Story: Nurturing a Greener Tomorrow</h1>
        <p className="text-gray-600 mb-6">
          TerraTalk began with a simple yet profound belief that conversation can inspire action.
          We’re a team of environmentalists, AI enthusiasts, and storytellers united by a shared passion for our planet.
          Every idea, every story, every narrative crafted is a step toward a more sustainable and harmonious future.
        </p>
        <button
          onClick={() => navigate("/action")}
          className="bg-violet-600 text-white px-6 py-2 rounded shadow hover:bg-violet-700 transition"
        >
          Learn How You Can Help
        </button>
      </section>

      {/* Ecosystem Stories with Images */}
      <section className="py-16 px-6 max-w-6xl mx-auto">
        <h2 className="text-2xl font-semibold text-center mb-10">Stories from Earth’s Voices</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {stories.map((eco, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition overflow-hidden"
            >
              <img src={eco.image} alt={eco.name} className="w-full h-40 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{eco.name}</h3>
                <p className="text-sm text-gray-600 mb-2">{eco.description}</p>
                <blockquote className="italic text-gray-500 text-sm mb-4">“{eco.snippet}”</blockquote>
                <button
                  onClick={() => navigate(eco.route)}
                  className="text-violet-600 font-medium text-sm hover:underline"
                >
                  Talk to Me →
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 px-4 text-center bg-gray-50">
        <h2 className="text-2xl font-semibold mb-8">Who We Are: Our Core Values</h2>
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto text-left text-sm text-gray-700">
          <div>🌱 <strong>Environmental Stewardship:</strong> Deeply committed to restoring Earth’s balance.</div>
          <div>📚 <strong>Innovative Education:</strong> Using AI to teach ecological understanding accessibly.</div>
          <div>🤝 <strong>Community Empowerment:</strong> Inspiring action and local eco-conscious leadership.</div>
          <div>🌍 <strong>Empathetic Connection:</strong> Bridging humanity and nature through emotion.</div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-gradient-to-r from-purple-500 to-indigo-600 text-white text-center py-12">
        <h2 className="text-2xl font-semibold mb-4">Ready to Start the Conversation?</h2>
        <p className="mb-6 text-sm max-w-xl mx-auto">
          Join thousands discovering Earth's voice through TerraTalk. Your empathy creates change.
        </p>
        <button
          onClick={() => navigate("/select")}
          className="bg-white text-indigo-700 px-6 py-3 rounded font-medium hover:bg-gray-100 transition"
        >
          Choose an Ecosystem →
        </button>
      </section>
    </div>
  );
}

export default StoryPage;
